module.exports = {
      id: "phone-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }